module.exports = __webpack_public_path__ + "img/musicPlayer_black.ab63e4bf.svg";